export class Converter {
  static singleQuotes = ['\'', '`', '′'];

  static doubleQuotes = ['"', '"', '"', '″'];

  constructor(table, defaultDimension, currentDimension) {
    this.table = table;
    this.defaultDimension = defaultDimension.toLowerCase();
    this.currentDimension = currentDimension.toLowerCase();
  }

  processTable() {
    this.table.querySelectorAll('table .wpdt-cell').forEach((cell) => {
      const cellText = cell.textContent.trim();

      if (!cellText || !/[a-zA-Zа-яА-ЯёЁ]/.test(cellText)) return;

      const cellTextLower = cellText.toLowerCase();

      if (cellTextLower.includes('feet') && this.currentDimension !== 'feet') {
        // eslint-disable-next-line no-param-reassign
        cell.textContent = cell.textContent.replace(/feet/gi, 'METERS');
      } else if (cellTextLower.includes('meters') && this.currentDimension !== 'meters') {
        // eslint-disable-next-line no-param-reassign
        cell.textContent = cell.textContent.replace(/meters/gi, 'FEET');
      }
    });

    this.table.querySelectorAll('.wpdt-cell').forEach((cell) => {
      this.processCell(cell);
    });
  }

  processCell(cell) {
    let currentText;
    let futureText = '';
    const originalValue = cell.getAttribute('data-original-value');
    const headerCell = Converter.getRelatedHeaderCell(cell);

    if (!Converter.isConvertableColumn(headerCell)) return;

    if (originalValue) {
      currentText = originalValue;
    } else {
      currentText = cell.textContent.trim();
    }

    if (Converter.shouldSkipCell(currentText)) return;

    if (!cell.hasAttribute('data-original-value')) {
      cell.setAttribute('data-original-value', currentText);
    }

    if (cell.hasAttribute('data-original-value') && this.defaultDimension === this.currentDimension) {
      futureText = cell.getAttribute('data-original-value');
    } else {
      const type = Converter.getType(currentText, headerCell);
      const newText = currentText.replace(/\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(\.\d+)?/g, (match) => this.convertNumber(match, type));
      futureText = newText;
    }

    // eslint-disable-next-line no-param-reassign
    cell.textContent = futureText;
  }

  convertNumber(match, type) {
    const hadComma = match.includes(',');
    let num = parseFloat(match.replace(/,/g, ''));

    if (Number.isNaN(num)) return match;

    if (this.currentDimension !== this.defaultDimension) {
      if (type === 'length') {
        num = this.currentDimension === 'feet'
          ? Converter.mToFt(num)
          : Converter.ftToM(num);
      } else if (type === 'area') {
        num = this.currentDimension === 'feet'
          ? Converter.m2ToFt2(num)
          : Converter.ft2ToM2(num);
      }
    }

    return hadComma ? Number(num).toLocaleString('en-US') : String(num);
  }

  static mToFt(m) {
    return Math.round(m * 3.28084);
  }

  static ftToM(ft) {
    return Math.round(ft / 3.28084);
  }

  static m2ToFt2(m2) {
    return Math.round(m2 * 10.7639);
  }

  static ft2ToM2(ft2) {
    return Math.round(ft2 / 10.7639);
  }

  static shouldSkipCell(value) {
    if (!value) return true;
    if (!/\d/.test(value)) return true;
    return !!value.replace(/[xX]/g, '').match(/[a-zA-Zа-яА-ЯёЁ]/);
  }

  static getRelatedHeaderCell(cell) {
    if (!cell) return null;

    // Get column index from data-col-index attribute
    const colIndex = cell.getAttribute('data-col-index');
    if (!colIndex) return null;

    // Find the table
    const table = cell.closest('table');
    if (!table) return null;

    // Get header row
    const headerRow = table.querySelector('thead tr:first-child') ?? table.querySelector('tbody tr:first-child');
    if (!headerRow) return null;

    // Get header cell by column index
    const headerCell = headerRow.querySelector(`th:nth-child(${parseInt(colIndex, 10) + 1})`) ?? headerRow.querySelector(`td:nth-child(${parseInt(colIndex, 10) + 1})`);
    if (!headerCell) return null;

    return headerCell;
  }

  static isConvertableColumn(columnHeaderCell) {
    const textContent = columnHeaderCell.textContent
      .trim()
      .toLowerCase();

    if (textContent.includes('feet') || textContent.includes('meters')) return true;

    return false;
  }

  static getType(value, headerCell) {
    const header = headerCell.textContent.toLowerCase().trim();
    const hasArea = this.singleQuotes.some((q) => value.includes(`${q}2`) || value.includes(`${q}²`))
      || this.doubleQuotes.some((q) => value.includes(`${q}2`) || value.includes(`${q}²`));

    const hasSquare = header.includes('square');

    if (hasSquare || hasArea) {
      return 'area';
    }

    return 'length';
  }
}
